export default __webpack_public_path__ + "static/media/auth.6c9f092a.jpeg";